<template>
  <div class="home">
    <div class="content" ref="homeContent">
      <section class="d-flex flex-grow-1" v-if="loaded">
        <b-container fluid class="d-flex flex-column">
          <b-row class="flex-grow-1">
            <b-col class="info px-0">
              <b-row class="page-header m-md-0 pt-3 text-center text-lg-left">
                <b-col lg="auto" class="d-flex align-items-center">
                  <img :src="logo" width="100" class="mb-3" :alt="name">
                </b-col>
                <b-col cols="12" lg="6" class="d-flex flex-column justify-content-center mb-3">
                  <h1 class="mb-0">{{ name }}</h1>
                  <h4 class="font-lighter mb-0">{{ (agenda != null)?agenda.name:'' }}</h4>
                </b-col>
                <b-col class="d-flex flex-column justify-content-center mb-3 text-lg-right">
                  <p class="mb-1" v-if="(telephone != null && telephone != '') || (cellphone != null && cellphone != '')">
                    <span v-if="telephone != null && telephone != ''"><i class="fal fa-phone mr-2"></i> {{ telephone }}</span>
                    <a v-if="cellphone != null && cellphone != ''" target="_blank" :href="'https://wa.me/55'+cellphone.replace(/\D/g, '')" :class="(telephone != null && telephone != '') ? 'ml-4' : ''"><i class="fab fa-whatsapp mr-2"></i> {{ cellphone }}</a>
                  </p>
                  <p class="mb-0"><i class="fal fa-map-marker-alt mr-2"></i> <span v-html="buildAddress(true)"></span></p>
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                  <b-row>
                    <b-col cols="12" class="mb-2" v-if="appointmentTimer != null">
                      <div class="alert alert-warning text-center" role="alert">
                        <p class="mb-0">O agendamento será cancelado automaticamente caso o pagamento não ocorra dentro de {{appointmentTimer}}</p>
                      </div>
                    </b-col>

                    <b-col cols="12" lg="6">
                      <div class="box-cj mb-3">
                        <div class="header">
                          Detalhes do agendamento
                        </div>
                        <div class="content shopping-cart">
                          <b-row class="mb-2">
                            <b-col cols="12 d-flex align-items-center mb-2">
                              <img src="@/assets/images/calendar.svg" class="icon" alt="Dia" />
                              Dia:&nbsp;<span>{{moment(appointment.start_datetime).format('DD/MM/YYYY (dddd)')}}</span>
                            </b-col>
                            <b-col cols="12 d-flex align-items-center mb-2">
                              <img src="@/assets/images/time.svg" class="icon" alt="Horário" />
                              Horário:&nbsp;<span>{{moment(appointment.start_datetime).format('HH:mm')}}</span>
                            </b-col>
                            <b-col cols="12 d-flex align-items-center mb-2">
                              <img src="@/assets/images/appointment-type.svg" class="larger-icon" alt="Consulta" />
                              <span>{{appointment.appointment_type}} {{appointment.appointment_format.toLowerCase()}} - R$ {{formatPrice(appointment.value)}}</span>
                            </b-col>
                            <b-col cols="12 d-flex align-items-start">
                              <img src="@/assets/images/address.svg" class="icon" alt="Endereço" />
                              <span v-html="buildAddress(false)"></span>
                            </b-col>
                            <b-col cols="12"><hr></b-col>
                            <b-col cols="12 d-flex align-items-center mb-2">
                              <img src="@/assets/images/patient.svg" class="icon" alt="Paciente" />
                              <span class="shopping-cart-subtitle">Dados do paciente</span>
                            </b-col>
                            <b-col cols="12 d-flex align-items-center mb-2">
                              <span class="icon"></span>
                              Nome:&nbsp;<span>{{appointment.patient.name}}</span>
                            </b-col>
                            <b-col cols="12 d-flex align-items-center mb-2">
                              <span class="icon"></span>
                              Celular:&nbsp;<span>{{appointment.patient.cellphone}}</span>
                            </b-col>
                            <b-col cols="12 d-flex align-items-start">
                              <span class="icon"></span>
                              Plano de Saúde:&nbsp;<span>{{appointment.health_plan}}</span>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <div class="box-cj mb-2" v-if="enablePaymentForm">
                        <div class="header">
                          Forma de pagamento
                        </div>
                        <div class="content">
                          <b-row class="mb-2">
                            <b-col cols="12" md="6" class="mb-2 mb-md-0" v-if="agenda && agenda.charge_payment_methods.indexOf('credit') >= 0">
                              <div :class="'payment-method pointer ' + (paymentForm.payment_method == 'credit' ? 'active' : '')" @click="setPaymentMethod('credit')">
                                <img src="@/assets/images/payment-method-card.svg" alt="Cartão de crédito" />
                                <span class="ml-1">Cartão de crédito</span>
                              </div>
                            </b-col>
                            <b-col cols="12" md="6" v-if="false">
                              <div :class="'payment-method pointer ' + (paymentForm.payment_method == 'boleto' ? 'active' : '')" @click="setPaymentMethod('boleto')">
                                <img src="@/assets/images/payment-method-boleto.svg" alt="Boleto" />
                                <span class="ml-2">Boleto</span>
                              </div>
                            </b-col>
                            <b-col cols="12" md="6" v-if="agenda && agenda.charge_payment_methods.indexOf('pix') >= 0 && (moment().format('DD/MM/YYYY') !== '20/01/2025' && moment().format('DD/MM/YYYY') !== '21/01/2025')">
                              <div :class="'payment-method pointer ' + (paymentForm.payment_method == 'pix' ? 'active' : '')" @click="setPaymentMethod('pix')">
                                <img src="@/assets/images/payment-method-pix.svg" alt="Pix" />
                                <span class="ml-2">Pix</span>
                              </div>
                            </b-col>
                            <b-col cols="12" v-if="paymentForm.payment_method">
                              <hr>
                              <div class="card-wrapper mt-3 mb-3" v-if="paymentForm.payment_method == 'credit'">
                                <Card v-model="cardForm"></Card>
                              </div>
                              <validation-observer ref="paymentForm" v-slot="{ invalid }">
                                <b-row v-if="paymentForm.payment_method == 'credit'">
                                  <b-col cols="12">
                                    <label class="cj-label">Número do cartão</label>
                                    <validation-provider name="número do cartão" :rules="{ required: true, cardNumber: true }" v-slot="{ errors }">
                                      <b-form-input type="tel" name="number" v-model="cardForm.number" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-card-focus></b-form-input>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </b-col>
                                  <b-col cols="12">
                                    <label class="cj-label">Nome no cartão</label>
                                    <validation-provider name="nome no cartão" :rules="{ required: true }" v-slot="{ errors }">
                                      <b-form-input type="text" name="name" v-model="cardForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-card-focus></b-form-input>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </b-col>
                                  <b-col cols="6">
                                    <label class="cj-label">Válido até</label>
                                    <validation-provider name="válido até" :rules="{ required: true, cardExpiry: true }" v-slot="{ errors }">
                                      <b-form-input type="tel" name="expiry" v-model="cardForm.expiry" :class="{ 'error': errors.length > 0 }" v-mask="'##/##'" autocomplete="off" v-card-focus></b-form-input>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </b-col>
                                  <b-col cols="6">
                                    <label class="cj-label">CVC</label>
                                    <validation-provider name="cvc" :rules="{ required: true, cardCvc: true }" v-slot="{ errors }">
                                      <b-form-input type="tel" name="cvc" v-model="cardForm.cvc" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-card-focus></b-form-input>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </b-col>
                                  <b-col cols="12" v-if="installmentOptions.length > 0" class="mt-2">
                                    <label class="cj-label">Parcelamento</label>
                                    <validation-provider name="parcelamento" :rules="{ required: true }" v-slot="{ errors }">
                                      <multiselect v-model="paymentForm.installments" :options="installmentOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Selecione o número de parcelas" @select="installmentSelected" :class="{ 'error': errors.length > 0 }"></multiselect>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </b-col>
                                  <b-col cols="12">
                                    <hr>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="12 mb-4 d-flex flex-row align-items-baseline">
                                    <div class="pretty p-default p-thick p-smooth">
                                      <input type="checkbox" v-model="acceptedPolicies" />
                                      <div class="state p-primary">
                                        <label></label>
                                      </div>
                                    </div>
                                    <label class="accept-policies"><span @click="acceptedPolicies = !acceptedPolicies">Aceito as</span>&nbsp;<i @click="showPolicies">políticas do consultório de cancelamento, reagendamento e não comparecimento</i>.</label>
                                  </b-col>
                                  <b-col cols="12">
                                    <b-button v-if="paymentForm.payment_method == 'credit'" block @click="makePayment" variant="primary" :disabled="!canPerformAction || !acceptedPolicies">Pagar R$ {{formatPrice(paymentForm.value)}}</b-button>
                                    <b-button v-else-if="paymentForm.payment_method == 'pix'" block @click="generatePix" variant="primary" :disabled="!canPerformAction || !acceptedPolicies">Gerar Pix de R$ {{formatPrice(appointment.value)}}</b-button>
                                  </b-col>
                                  <b-col cols="12">
                                    <hr>
                                    <p class="cancel-link text-center mb-0" @click="cancel">Desejo <span>cancelar o agendamento</span> e não efetuar o pagamento</p>
                                  </b-col>
                                </b-row>
                              </validation-observer>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <div class="box-cj mb-2" v-else>
                        <div class="header">
                          Dados do pagamento
                        </div>
                        <div class="content">
                          <b-row class="mb-2">
                            <b-col v-if="invoice.payment_method == 'credit'">
                              <b-row class="mb-2">
                                <b-col cols="6">
                                  <label class="cj-label">Dados do cartão</label>
                                  <div class="w-100 d-flex align-items-center">
                                    <img :src="getCardBrandImage(invoice.card_brand)" height="30px" class="mr-2" :alt="invoice.card_brand" />
                                    <span class="mr-5">{{ invoice.card_bin }} **** **** ****</span>
                                  </div>
                                </b-col>
                                <b-col>
                                  <label class="cj-label">Status</label>
                                  <div class="w-100">
                                    <span>{{invoiceStatusOptions.find(g => g.value == invoice.status).name}}</span>
                                  </div>
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col>
                                  <label class="cj-label">ID da transação</label>
                                  <div class="w-100">
                                    <span>{{invoice.zoop_id}}</span>
                                  </div>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col v-else-if="invoice.payment_method == 'pix'">
                              <template v-if="invoice.status == 'pending'">
                                <b-row class="mb-3">
                                  <b-col cols="6">
                                    <label class="cj-label">Pix</label>
                                    <div class="w-100 d-flex align-items-center">
                                      <img src="@/assets/images/payment-method-pix.svg" alt="Pix" height="30px" class="mr-2"/>
                                      <span class="mr-5" v-if="invoice.pix_qr_code !== null">Válido até {{ moment(invoice.pix_valid_until).format('DD/MM/YY HH:mm') }}</span>
                                      <span class="mr-5" v-else>Expirado</span>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mb-3" v-if="invoice.pix_qr_code !== null">
                                  <b-col cols="12" class="mb-3">
      <!--                              <label class="cj-label"></label>-->
                                    <p class="pix-qr-code-text text-center mb-2">Leia o QRCode abaixo no seu celular para realizar o pagamento</p>
                                    <div class="w-100 text-center mb-2">
                                      <qrcode-vue :value="invoice.pix_qr_code" size="250" level="H"></qrcode-vue>
                                    </div>
                                    <label class="cj-label">Pix copia e cola</label>
                                    <div class="w-100">
                                      <span class="pix-qr-code-text">
                                        {{ invoice.pix_qr_code }}
            <!--                            <b-button size="sm" @click="copyPixQrCode"><i class="far fa-copy"></i></b-button>-->
                                        <b-form-textarea class="copyPixQrCodeTextArea" :value="invoice.pix_qr_code" ref="pixQrCode"></b-form-textarea>
                                      </span>
                                    </div>
                                  </b-col>
                                  <b-col cols="12">
                                    <b-button block variant="primary" @click="copyPixQrCode">Copiar</b-button>
                                    <p class="text-center mt-2">Aguardando o pagamento</p>
                                  </b-col>
                                  <b-col cols="12">
                                    <hr>
                                    <p class="cancel-link text-center mb-0" @click="cancelPix">Desejo <span>escolher outro meio de pagamento</span></p>
                                  </b-col>
                                </b-row>
                              </template>
                              <template v-else>
                                <b-row class="mb-2">
                                  <b-col cols="6">
                                    <label class="cj-label">Identificador</label>
                                    <div class="w-100">
                                      <span>{{ invoice.pix_id }}</span>
                                    </div>
                                  </b-col>
                                  <b-col>
                                    <label class="cj-label">Status</label>
                                    <div class="w-100">
                                      <span>{{invoiceStatusOptions.find(g => g.value == invoice.status).name}}</span>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col>
                                    <label class="cj-label">ID da transação</label>
                                    <div class="w-100">
                                      <span>{{invoice.zoop_id}}</span>
                                    </div>
                                  </b-col>
                                </b-row>
                              </template>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <p class="credits text-center mb-4">Ambiente seguro&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Powered by <a href="https://consultaja.com" target="_blank">Consultaja.com</a></p>
                    </b-col>


                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>

      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'home',
  data() {
    return {
      isLoading: null,

      loaded: false,

      enablePaymentForm:true,

      acceptedPolicies: false,

      interval: null,
      appointmentTimerInterval: null,
      appointmentTimer: null,

      cardForm: {
        number: '',
        brand: '',
        name: '',
        expiry: '',
        cvc: ''
      },

      paymentForm: {
        payment_method: 'credit',

        card_token: null,
        installments: null,
        value: null
      },

      invoiceStatusOptions: [
        { value: 'new', name: 'Em processamento' }, //alterado p/ pacientes
        { value: 'pending', name: 'Em processamento' }, //alterado p/ pacientes
        { value: 'pre_authorized', name: 'Pré-autorizado' },
        { value: 'succeeded', name: 'Pago' },
        { value: 'failed', name: 'Recusado' },
        { value: 'reversed', name: 'Revertido' },
        { value: 'canceled', name: 'Cancelado' },
        { value: 'refunded', name: 'Reembolsado' },
        { value: 'dispute', name: 'Em disputa' },
        { value: 'charged_back', name: 'Devolvido' }
      ],

      installmentOptions: [],

      logo: require('@/assets/images/avatar.svg'),
      name: null,
      cellphone: null,
      telephone: null,
      email: null,
      address: null,
      agenda: null,
      appointment: null,
      invoice: null,

      canPerformAction: true,

      appointmentForm: {
        start_datetime: null,
        name: null,
        email: null,
        document: null,
        birthday: null,
        cellphone: null,
        alreadyPatient: null,
        health_plan: null
      },
      alreadyPatient: [
        { value: false, name: 'Não' },
        { value: true, name: 'Sim' }
      ]
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null)
          this.isLoading.hide();
      }
    });

    this.eventBus.$emit('IS_LOADING', true);
    this.canPerformAction = false;

    this.getAppointment();
  },
  methods: {
    getAppointment() {
      this.api.getAppointment(this.$route.params.agendaId, this.$route.params.id).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
        this.loaded = true;

        let appointmentData = res.data;
        if(appointmentData.professional_photo) {
          this.logo = appointmentData.professional_photo;
        }
        else if(appointmentData.agenda_logo) {
          this.logo = appointmentData.agenda_logo;
        }
        else if(appointmentData.logo) {
          this.logo = appointmentData.logo;
        }
        this.name = appointmentData.name;
        this.cellphone = appointmentData.cellphone;
        this.telephone = appointmentData.telephone;
        this.email = appointmentData.email;
        this.address = appointmentData.address;
        this.agenda = appointmentData.agenda;
        this.appointment = appointmentData.appointment;
        this.cardForm.name = this.appointment.patient.name;

        this.appointmentTimerInterval = setInterval(this.setAppointmentTimer, 1000);

        this.paymentForm.value = this.appointment.value;

        this.installmentOptions = [];
        this.appointment.installments.forEach(installment => {
          let text = installment.installments == 1 ? 'À vista' : (installment.installments + 'x de R$ ' + this.formatPrice(installment.installment_value) + (installment.fees === 0 ? ' sem juros' : ' com juros'));
          this.installmentOptions.push({ value: installment.installments, name: text, total: installment.total_value });
        });

        this.invoice = appointmentData.invoice;
        this.enablePaymentForm = this.invoice == null || this.invoice.status == 'failed';
        if(this.invoice != null) {
          if(this.invoice.status == 'failed') {
            this.$swal('Ops...', 'A sua última tentativa de pagamento foi reprovada. Por favor, tente novamente.', 'warning');
          }
          else if(this.invoice.payment_method == 'pix' && this.invoice.status == 'pending') {
            this.interval = setInterval(this.checkPix, 15*1000);
          }
        }

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Success Get Appointment', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        let response = err.response;

        let message = 'Não conseguimos carregar os dados! Por favor, tente novamente.';
        switch (response.status) {
          case 422: message = response.data.errors.join('\r\n'); break;
          case 400: message = response.data.message; break;
        }
        if(response.data.return_to_online_scheduling) {
          this.$swal({
            title: message,
            type: 'error',
            showCancelButton: true,
            confirmButtonText: 'Ver agenda',
            cancelButtonText: 'Sair',
            focusConfirm: true
          }).then((res) => {
            if(res.value) {
              window.location.href = process.env.VUE_APP_AOL_URL + this.$route.params.agendaId;
            }
            else {
              this.$router.go();
            }
          });
        }
        else {
          let reload = response.data.reload;
          this.$swal('Ops...', message, 'error').then(() => {
            if(reload) {
              this.$router.go();
            }
          });
        }

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Error Get Appointment', err.response);
      });
    },
    setAppointmentTimer() {
      let diff = this.moment(this.appointment.created_at).add(30, 'minutes').diff(this.moment(), 'seconds');
      if(diff <= 0) {
        clearInterval(this.appointmentTimerInterval);
        this.appointmentTimerInterval = null;
        this.appointmentTimer = '00:00';
      }
      else {
        this.appointmentTimer = this.moment.duration(diff, 'seconds').format('mm:ss', { trim: false });
      }
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    getCardBrandImage(brand) {
      return require('../assets/images/'+brand.replace(/ /g, '').toLowerCase()+'.svg');
    },
    buildAddress(breakLine) {
      if(this.address != null) {
        return this.address.address+', '+this.address.number+(breakLine ? '<br>' : ' - ')+this.address.city+', '+this.address.state;
      }
    },
    setPaymentMethod(method) {
      this.paymentForm.payment_method = method;
      if(method == 'boleto') {
        this.appointment.value = installment.total;
      }
      else if(this.paymentForm.installments) {
        this.paymentForm.value = this.paymentForm.installments.total;
      }
    },
    installmentSelected(installment) {
      this.paymentForm.value = installment.total;
    },
    showPolicies() {
      let policies = this.agenda.policies != null ? (this.agenda.policies + "\n\n") : '';
      policies += "Para maiores informações sobre a política do consultório quanto a agendamento, remarcação e consultas entre em contato conosco.\n\n" +
          this.name;
      if(this.telephone != null && this.telephone != '') {
        policies += "\nTelefone: " + this.telephone;
      }
      if(this.cellphone != null && this.cellphone != '') {
        policies += "\nCelular / Whatsapp: " + '<a _target="_blank" href="https://wa.me/55'+this.cellphone.replace(/\D/g, '')+'">' + this.cellphone + '</a>';
      }
      this.$swal({
        // title: 'Politicas',
        // type: 'info',
        html: '<div class="text-left font-weight-bold mb-3">Políticas de cancelamento, reagendamento e não comparecimento</div><div class="text-left policies-text">' + policies.replace(/\n/g, '<br>') + '</div>',
        width: '800px'
      });
    },
    async makePayment() {
      const isValid = await this.$refs.paymentForm.validate();
      if(!isValid) {
        return false;
      }

      this.canPerformAction = false;
      this.eventBus.$emit('IS_LOADING', true);

      let paymentData = this.paymentForm;
      paymentData.device_user_agent = navigator.userAgent;
      paymentData.device_color_depth = screen.colorDepth;
      paymentData.device_java_enabled = navigator.javaEnabled() ? 1 : 0;
      paymentData.device_language = navigator.language;
      paymentData.device_screen_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      paymentData.device_screen_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      paymentData.device_timezone_offset = (new Date()).getTimezoneOffset()/60;
      if(paymentData.installments) {
        paymentData.installments = paymentData.installments.value;
      }

      let cardData = this.formatCardData();
      await axios.post('https://api.zoop.ws/v1/marketplaces/' + atob(process.env.VUE_APP_TOKENIZE_CARD_KEY) + '/cards/tokens', cardData, {
        headers: {
          'Authorization': 'Basic ' + process.env.VUE_APP_TOKENIZE_CARD_SECRET
        }
      }).then(res => {
        console.log('Response Make Payment Card', res);
        paymentData.card_token = res.data.id;
        this.api.makePayment(this.$route.params.agendaId, this.$route.params.id, paymentData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let message = res.data.status == 'PAID' ? 'Seu pagamento foi aprovado!' : 'Seu pagamento está sendo processado pela operadora e será confirmado em breve!';
          this.$swal('Uhull \\o/', message, 'success').then(() => {
            this.$router.go();
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Make Payment Card', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let response = err.response;

          let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
          switch (response.status) {
            case 422: message = response.data.errors.join('\r\n'); break;
            case 400:  {
              if(typeof response.data.message != 'undefined' && response.data.message != '') {
                if(response.data.message.indexOf('card_declined:') >= 0) {
                  message = 'O seu cartão foi recusado. Para mais informações, entre em contato com a operadora do seu cartão.';
                }
                else if(response.data.message.indexOf('service_request_timeout:') >= 0) {
                  message = 'O serviço de pagamento está temporariamente indisponível. Por favor, aguarde um momento e tente novamente.';
                }
                else {
                  message = response.data.message;
                }
              }
              break;
            }
          }

          if(response.data.return_to_online_scheduling) {
            this.$swal({
              title: message,
              type: 'error',
              showCancelButton: true,
              confirmButtonText: 'Ver agenda',
              cancelButtonText: 'Sair',
              focusConfirm: true
            }).then((res) => {
              if(res.value) {
                window.location.href = process.env.VUE_APP_AOL_URL + this.$route.params.agendaId;
              }
              else {
                this.$router.go();
              }
            });
          }
          else {
            let reload = response.data.reload;
            this.$swal('Ops...', message, 'error').then(() => {
              if(reload) {
                this.$router.go();
              }
            });
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Make Payment Card', err);
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response tokenize card', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
        this.$swal('Ops...', 'Parece que tem algum problema com seu cartão! Verifique as informações digitadas e tente novamente.', 'error');

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error tokenize card', err.response);
      });
    },

    async generatePix() {
      const isValid = await this.$refs.paymentForm.validate();
      if(!isValid) {
        return false;
      }

      this.canPerformAction = false;
      this.eventBus.$emit('IS_LOADING', true);

      let paymentData = this.paymentForm;
      paymentData.installments = null;
      this.api.generatePix(this.$route.params.agendaId, this.$route.params.id, paymentData).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        this.$router.go();

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Generate Pix', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
        let response = err.response;

        let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
        switch (response.status) {
          case 422: message = response.data.errors.join('\r\n'); break;
          case 400:  {
            if(typeof response.data.message != 'undefined' && response.data.message != '') {
              if(response.data.message.indexOf('service_request_timeout:') >= 0) {
                message = 'O serviço de pagamento está temporariamente indisponível. Por favor, aguarde um momento e tente novamente.';
              }
              else {
                message = response.data.message;
              }
            }
            break;
          }
        }

        if(response.data.return_to_online_scheduling) {
          this.$swal({
            title: message,
            type: 'error',
            showCancelButton: true,
            confirmButtonText: 'Ver agenda',
            cancelButtonText: 'Sair',
            focusConfirm: true
          }).then((res) => {
            if(res.value) {
              window.location.href = process.env.VUE_APP_AOL_URL + this.$route.params.agendaId;
            }
            else {
              this.$router.go();
            }
          });
        }
        else {
          let reload = response.data.reload;
          this.$swal('Ops...', message, 'error').then(() => {
            if(reload) {
              this.$router.go();
            }
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Generate Pix', err);
      });
    },

    async checkPix() {
      this.api.checkPix(this.$route.params.agendaId, this.$route.params.id).then(res => {
        let invoiceData = res.data.invoice;
        if(invoiceData == null) {
          this.$swal('Ops...', 'O Pix expirou.', 'warning').then(() => {
            this.$router.go();
          });
        }
        else if(invoiceData.status == 'PAID') {
          this.$swal('Uhull \\o/', 'Seu pagamento foi aprovado!', 'success').then(() => {
            this.$router.go();
          });
        }
        else {
          this.invoice = invoiceData;
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Check Pix', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
        let response = err.response;

        let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
        switch (response.status) {
          case 422: message = response.data.errors.join('\r\n'); break;
          case 400:  {
            if(typeof response.data.message != 'undefined' && response.data.message != '') {
              if(response.data.message.indexOf('service_request_timeout:') >= 0) {
                message = 'O serviço de pagamento está temporariamente indisponível. Por favor, aguarde um momento e tente novamente.';
              }
              else {
                message = response.data.message;
              }
            }
            break;
          }
        }

        if(response.data.return_to_online_scheduling) {
          this.$swal({
            title: message,
            type: 'error',
            showCancelButton: true,
            confirmButtonText: 'Ver agenda',
            cancelButtonText: 'Sair',
            focusConfirm: true
          }).then((res) => {
            if(res.value) {
              window.location.href = process.env.VUE_APP_AOL_URL + this.$route.params.agendaId;
            }
            else {
              this.$router.go();
            }
          });
        }
        else {
          let reload = response.data.reload;
          this.$swal('Ops...', message, 'error').then(() => {
            if(reload) {
              this.$router.go();
            }
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Check Pix', err);
      });
    },

    cancelPix() {
      this.$swal({
        title: 'Você tem certeza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Trocar meio de pagamento',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.eventBus.$emit('IS_LOADING', true);
          this.canPerformAction = false;

          this.api.cancelPix(this.$route.params.agendaId, this.$route.params.id).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            this.$router.go();

            if(process.env.VUE_APP_SHOW_CONSOLE)
              console.log('Success Cancel Pix', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let response = err.response;
            let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este Pix! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

            this.$swal('Ops...', message, 'error').then(() => {
              this.$router.go();
            });

            if(process.env.VUE_APP_SHOW_CONSOLE)
              console.log('Error Cancel Pix', err.response);
          });
        }
      });
    },

    cancel() {
      this.$swal({
        title: 'Você tem certeza de que deseja cancelar o agendamento?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.eventBus.$emit('IS_LOADING', true);
          this.canPerformAction = false;

          this.api.cancelAppointment(this.$route.params.agendaId, this.$route.params.id).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            this.$swal({
              title: 'Agendamento cancelado com sucesso!',
              type: 'success',
              showCancelButton: true,
              confirmButtonText: 'Ver agenda',
              cancelButtonText: 'Sair',
              focusConfirm: true
            }).then((res) => {
              if(res.value) {
                window.location.href = process.env.VUE_APP_AOL_URL + this.$route.params.agendaId;
              }
              else {
                this.$router.go();
              }
            });

            if(process.env.VUE_APP_SHOW_CONSOLE)
              console.log('Success Cancel Appointment', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let response = err.response;
            let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

            this.$swal('Ops...', message, 'error');

            if(process.env.VUE_APP_SHOW_CONSOLE)
              console.log('Error Cancel Appointment', err.response);
          });
        }
      });
    },

    formatCardData() {
      let expiryParts = this.cardForm.expiry.split('/');
      let cardData = {
        holder_name: this.cardForm.name,
        card_number: this.cardForm.number.replace(/\D/g,''),
        security_code: this.cardForm.cvc,
        expiration_month: expiryParts[0].trim(),
        expiration_year: expiryParts[1].trim(),
      };
      return cardData;
    },

    copyPixQrCode() {
      this.$refs.pixQrCode.select();
      document.execCommand('copy');
      this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.interval != null) {
      clearInterval(this.interval);
      this.interval = null;
    }
    if(this.appointmentTimerInterval != null) {
      clearInterval(this.appointmentTimerInterval);
      this.appointmentTimerInterval = null;
    }
    next();
  }
}
</script>

<style lang="scss">
  .home {
    display: flex;
    overflow: hidden;
    width: 100%;
    min-height: 100vh;

    > .content {
      flex: 1;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
      background: #F4F4F4;
    }

    .info {
      .page-header {
        background: #fff;

        h1 {
          font-size: 24px;
        }
        h4 {
          font-size: 18px;
        }
        p, a {
          font-family: 'sf_pro_displayregular';
          color: #90A6B3;
        }
      }

      .box-cj {
        background: #FFFFFF;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        margin-bottom: 30px;

        &.box-collapse {
          margin-bottom: -5px;
          border-radius: 4px 4px 0 0;
        }

        .header {
          padding: 15px 20px;
          border-bottom: 1px solid $athenGray2;

          .title {
            font-size: 16px;
            margin-bottom: 0;
          }
        }

        .footer {
          padding: 15px 20px;
          border-top: 1px solid $athenGray2;
        }

        .content {
          padding: 15px 20px;

          .sub-title {
            font-size: 16px;
            margin-bottom: 15px;
            color: $waikawaGray;
          }

          .valid-between {
            li {
              border: 1px solid $mystic;
              padding: 10px 20px;

              .label {
                width: 100%;
                font-size: 12px;
                color: $cadetGray;
                float: left;
                margin-bottom: -5px;
              }

              .date {
                font-size: 16px;
                color: $waikawaGray;
              }

              &:first-child {
                border-radius: 4px 4px 0 0;
              }

              &:last-child {
                border-top: 0;
                border-radius: 0 0 4px 4px;
              }
            }
          }

          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 16px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }
          }
        }
      }

      .shopping-cart {
        color: $cadetGray;
        font-family: 'sf_pro_displayregular';

        .icon {
          width: 20px;
          margin-right: 14px;
        }
        .larger-icon {
          width: 24px;
          margin: 0 11px 0 -1px;
        }
        span {
          font-family: 'sf_pro_displaysemibold';
        }
        .shopping-cart-subtitle {
          color: #2A3748;
        }
      }

      .payment-method {
        border: 1px solid $mystic;
        border-radius: 4px;
        padding: 10px;
        color: $blueBayoux;

        img {
          height: 26px;
        }

        &:hover {
          border-color: $columbiaBlue;
        }

        &.active {
          border-color: $curiousBlue;
        }
      }

      .jp-card {
        min-width: 0;
      }
    }

    .pretty .state label:before{
      border-color: #707070;
    }
    .accept-policies {
      font-family: 'sf_pro_displayregular';
      color: $cadetGray;

      i {
        cursor: pointer;
        color: $curiousBlue;
      }
    }

    .cancel-link {
      font-family: 'sf_pro_displayregular';
      color: $cadetGray;
      cursor: pointer;

      span {
        font-family: 'sf_pro_displaysemibold';
      }
    }

    .credits {
      font-family: 'sf_pro_displayregular';
      font-size: 14px;
      color: $cadetGray;

      a {
        font-family: 'sf_pro_displaysemibold';
        color: $cadetGray;
      }
    }

    .font-lighter {
      font-family: 'sf_pro_displaylight';
    }

    .font-2x {
      font-size: 1.5em;
    }

    .v2 {

      .pointer {
        cursor: pointer;
      }

      .disabled {
        opacity: 0.5;
        cursor: unset;
      }

      .btn.btn-primary {
        background-color: $tangaroa;
        border-color: $tangaroa;
        color: #ffffff;
      }
    }

    .copyPixQrCodeTextArea {
      width: 1px;
      height: 1px;
      padding: 0;
      opacity: 0;
    }

    .pix-qr-code-text {
      font-size: .9rem;
    }
  }
  .policies-text {
    font-size: 14px;
  }
</style>
